export enum OcbAzureStorageServices {
    Files = 0,
    Blobs = 1,
}
